import Actions from '../actions'

const defaultState = {
  user: null,
  friends: {},
  games: {},
  isLoggingIn: false,
  loginResponse: '',
}

function setUser (state, user) {
  return { ...state,
    user: user
  }
}

function setFriends (state, friends) {
  return { ...state,
    friends: friends
  }
}

function setGames (state, games) {
  return { ...state,
    games: games
  }
}

function appendGame (state, game) {
  return { ...state,
    games: { ...state.games, 
      [game.id]: game,
    }
  }
}


function userReducer (state = defaultState, action) {
  switch (action.type) {
    case Actions.USER_SET_USER:
      return setUser(state, action.payload)
    case Actions.USER_SET_FRIENDS:
      return setFriends(state, action.payload)
    case Actions.USER_SET_GAMES:
      return setGames(state, action.payload)
    case Actions.USER_APPEND_GAME:
      return appendGame(state, action.payload)
    case Actions.USER_SET_IS_LOGGING_IN:
      return { ...state, isLoggingIn:action.payload}
    case Actions.USER_SET_LOGIN_RESPONSE:
      return { ...state, loginResponse:action.payload}
    case Actions.USER_CLEAR:
      return defaultState

    default:
      return state
  }
}

export default userReducer
